import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { defaultLang } from '../config';

// ----------------------------------------------------------------------

type LocaleResource = { [key: string]: string | LocaleResource };

/* eslint-disable @typescript-eslint/no-var-requires */
const enLocales: LocaleResource = require('./json/en.json');
const esLocales: LocaleResource = require('./json/es.json');
const esESLocales: LocaleResource = require('./json/es-ES.json');
const frLocales: LocaleResource = require('./json/fr.json');
const ptLocales: LocaleResource = require('./json/pt-BR.json');
const deLocales: LocaleResource = require('./json/de.json');
/* eslint-enable @typescript-eslint/no-var-requires */

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translations: enLocales },
            es: { translations: esLocales },
            'es-ES': { translations: esESLocales },
            fr: { translations: frLocales },
            'pt-BR': { translations: ptLocales },
            de: { translations: deLocales },
        },
        lng: localStorage.getItem('i18nextLng') || defaultLang.value,
        // English last: several sections (e.g. availability.scheduler) exist
        // only in en.json, and would otherwise render as raw keys.
        fallbackLng: [defaultLang.value, 'en'],
        debug: false,
        ns: ['translations'],
        defaultNS: 'translations',
        interpolation: {
            escapeValue: false,
        },
        react: {
            // Re-render components using useTranslation when addResourceBundle fires
            // the store 'added' event (required for lazy-loaded assignment locales).
            bindI18nStore: 'added removed',
        },
    });

export default i18n;
